import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom'
import { data } from 'cheerio/lib/api/attributes';
import { useTranslation } from "react-i18next";

import { get360Data, goToTop, getLoading, setCursorWaiting } from '../../../utils';

import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import GTMHelper from '../../../Helpers/gtmHelper';
import NavHelper from '../../../Helpers/navhelper';
import ThreeSixtyContainer from '../../3_Organisms/360Container/360Container';
import TrimList from '../../3_Organisms/TrimList/TrimList'
import { Pricing } from '../../3_Organisms/Pricing/Pricing';
import { Modal } from '../../3_Organisms/Modal/Modal';
import { PreOrderModal } from '../../3_Organisms/Modal/PreOrderModal';
import { Nav } from '../../3_Organisms/Nav/Nav';
import { Alert } from '../../3_Organisms/Alert/Alert';

export const TrimsPage = ({summaryCalculator = window.summaryCalculator, ...props }) => {
    const { year, carline } = useParams();

    const [images, setImages] = useState({});
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [is360Loading, setIs360Loading] = useState(true);    
    const [firstEmptyDataLoad, setFirstEmptyDataLoad] = useState(false);
    const [fromTrimSelection, setFromTrimSelection] = useState(false);
    const [dataNeedUpdate, setDataNeedUpdate] = useState(false);
    const legalContent = JSON.parse(sessionStorage.getItem(Constants.LegalTrims));
    const [legalModalOpen, setLegalModalOpen] = useState(false);
    const [showFinancePrice, setShowFinancePrice] = React.useState(summaryCalculator.ShowFinancePrice);
    const [selectedTrimIndex, setSelectedTrimIndex] = useState(null);
    const { t, i18n } = useTranslation(['trims', 'general']);
    const [nav, setNav] = React.useState(null);

    const [preorderOpen, setPreorderModalOpen] = React.useState(false);

    const navHelper = new NavHelper();
	const gtmHelper = new GTMHelper();
        
    summaryCalculator.CurrentStep = 1;
    
    function set360images() {
        if(!summaryCalculator.Colours)
            return;

        if (!Object.keys(images).length) {
            summaryCalculator.SetSelectedColorsFromParams();

            if (summaryCalculator.SelectedColourExteriorIndex > -1 && summaryCalculator.Colours) {
                const extArray = Object.entries(summaryCalculator.Colours.visual.exteriors);
                setImages(get360Data(summaryCalculator.Colours.visual, extArray[summaryCalculator.SelectedColourExteriorIndex][1], summaryCalculator.Colours.visual.interiors[summaryCalculator.SelectedColourInteriorIndex]));
                setIs360Loading(false);
            } else if (summaryCalculator.AvailableTrim) {
                setImages(get360Data(summaryCalculator.AvailableTrim.trims[summaryCalculator.SelectedTrimIndex].visual));
                setIs360Loading(false);
            }
        }
    }

    function nextStep() {
		let url;
        if (summaryCalculator.SelectedTrim) {
            goToTop();
            url=`/${year}/${carline}/${summaryCalculator.SelectedTrimUrlSlug}${decodeURI(window.location.search)}`;
        } else {
            goToTop();
            url=`/${year}/${carline}/${summaryCalculator.DefaultTrimUrlSlug}${decodeURI(window.location.search)}`;
        }
		navigate(url);
		gtmHelper.setGTM({'action':'Next Step'}, true , false);
    }

    async function handleSelectTrim(index) {
        setImages({});

        setFromTrimSelection(true);

        setSelectedTrimIndex(index);

        setDataNeedUpdate(true);
    }

    function hideShownCmsBlock() {
        let toHideBlocks = document.querySelectorAll('.mz-footer.visually-shown');
        if (toHideBlocks) {
            toHideBlocks.forEach(function (e) {
                e.classList.remove('visually-shown');
                e.classList.add('visually-hidden');
            });
        }
    }

    hideShownCmsBlock();

    goToTop();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    React.useEffect(() => {
        async function executeTasks() {
            if (window.bnp_under_maintenance)
                return;
                
            if (!firstEmptyDataLoad) {
                setCursorWaiting(true);

                setFirstEmptyDataLoad(true);

                if (!summaryCalculator.isDataLoaded()) {
                    summaryCalculator.reset(false);

                    await summaryCalculator.loadVehicleData(year, carline);

                    if (JSON.parse(sessionStorage.getItem(Constants.HasFinancialProviderError)) === true) {
                        const vehiclePageUri = `/${decodeURI(window.location.search)}`;
                        navigate(vehiclePageUri)
                    }
                }
                else
                {
                    setImages({});
                }

                setSelectedTrimIndex(summaryCalculator.SelectedTrimIndex);

                setDataNeedUpdate(true);

                setLoading(false);

                setCursorWaiting(false);
            }

            if (!loading) {
                if (dataNeedUpdate) {
                    setDataNeedUpdate(false);

                    setLoading(true);

                    if (selectedTrimIndex !== summaryCalculator.SelectedTrimIndex) {
                        setCursorWaiting(true);

                        if( fromTrimSelection ) {
                            summaryCalculator.reset(false);
                            setFromTrimSelection(false);
                        }

                        await summaryCalculator.setSelectedTrimIndex(selectedTrimIndex);

						gtmHelper.setGTM({'action':'Trim Change'}, false, false);

                        setCursorWaiting(false);
                    }

                    const toRender = navHelper.getNavContent(t);
                    setNav(toRender);

                    if (Object.keys(images).length === 0) {
                        set360images();
                    }

                    setLoading(false);
                }
            }
        }

        executeTasks();
    }, [summaryCalculator, loading, dataNeedUpdate, images, selectedTrimIndex, is360Loading]);

    function handleShowFinanceClick(value) {
        summaryCalculator.ShowFinancePrice = value;
        setShowFinancePrice(value);
    }

    function getContent() {
        return (
            <div className="mz-trims-page mz-top-nav-spacing grid-no-gutter-sm">
                <Nav nav={nav} />
                <Alert />
                {summaryCalculator.AvailableTrim && summaryCalculator.AvailableTrim?.trims?.length ?
                    <div key='0' className="mz-full-width mz-trims-page__content general-content">
                        <div className="mz-trims-page__content-left"> 
                             <ThreeSixtyContainer imagePathInterior={images.imagePathInterior} imagePath={images.imagePath} imageAmount={images.imageAmount} imageName={images.imageName} trimName={summaryCalculator.VehicleTitle} imageIsLoading={is360Loading} />
                        </div>
                        <div className="mz-trims-page__content-right right-container">
                            <TrimList trims={summaryCalculator.AvailableTrim.trims} setSelectedTrim={handleSelectTrim} selectedTrim={summaryCalculator.SelectedTrimIndex} setLegalModalOpen={setLegalModalOpen} showFinancePrice={showFinancePrice}/>
                        </div>
                    </div>
                    : null}

                {summaryCalculator.AvailableTrim && summaryCalculator.AvailableTrim?.trims?.length ?
                    <Pricing builtLabel={t("general:price_as_built")} builtPrice="$" loanLabel={t("general:loan_label")} loanPrice="$"
                        leaseLabel={t("general:show_lease_price")} financeLabel={t("general:show_finance_price")} buttonLabel={t("general:next_options")} saveLabel={t("general:save_build")}
                        HandleNextClick={nextStep} setLegalModalOpen={setLegalModalOpen} HandleShowFinanceClick={handleShowFinanceClick} setPreorderModalOpen={setPreorderModalOpen} /> : null}
                <Modal modalContent={legalContent} isOpen={legalModalOpen} handleClose={setLegalModalOpen} modalId='legalModal' />
                <PreOrderModal isOpen={preorderOpen} handleClose={setPreorderModalOpen}></PreOrderModal> 
            </div>
        )
    }

    return (
        <>
            {getLoading(loading, t)}
            {getContent()}
        </>
    )
}

export default TrimsPage;